module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-my-recommendations.svg?86b2350c305345279b70119ba164aa0c";